export const MENU = {
  DASHBOARD: 1,
  VISIT: 2,
  PAD: 3,
  PEP: 4,
  USERS: 5,
  REPORT: 6,
  REGISTRATION: 7,
  ORGANIZATIONAL: 8,
  TERMINOLOGY: 9
};
